
import React from 'react';

interface UseCaseFileProps {
  patientId: string;
}

const UseCaseFile: React.FC<UseCaseFileProps> = ({ patientId }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow mb-6">
      <h2 className="text-xl font-semibold mb-4">Patient Case File</h2>
      <p className="mb-2">Patient ID: {patientId}</p>
      <p>This is a placeholder for the patient case file component.</p>
    </div>
  );
};

export default UseCaseFile;
